import React from 'react';
import { Droplet, Waves, Trash2, Percent, Tag, Zap, Flame } from "lucide-react";
import { ChargesFeesBreakdown } from './plan-and-deposit/ChargesFeesBreakdown';
import { PlanDetails } from './plan-and-deposit/PlanDetails';
import { RateStructures } from './plan-and-deposit/RateStructures';
import { SecurityDeposit } from './plan-and-deposit/SecurityDeposit';
import { getLoginDataFromStorage } from '@shared/utils/loginUtils';
import { getRemoteUtilityId } from '@shared/utils/getUtilityId';
import { useConsumerPlanConfig } from '../hook';

export function PlanAndDeposit() {
  const { consumerId } = getLoginDataFromStorage() || {};
  const remoteUtilityId = getRemoteUtilityId();

  const { data: planConfig } = useConsumerPlanConfig({
    consumer_id: consumerId,
    remote_utility_id: remoteUtilityId
  });

  return (
    <div className="w-full">
      <PlanDetails planConfig={planConfig} />
      <RateStructures planConfig={planConfig} />
      <ChargesFeesBreakdown planConfig={planConfig} />
      <SecurityDeposit planConfig={planConfig} />
    </div>
  );
}

export default PlanAndDeposit;
